/**
 * French status label and color maps
 * Transcribed verbatim from API enums: SessionStatus and ProfileStatus
 * Single source of truth for status badges — never hardcode labels elsewhere.
 */

/**
 * SessionStatus labels and Tailwind color classes
 * Values from: app/Enums/SessionStatus.php
 */
export const SESSION_STATUS_LABELS = {
  scheduled: 'Prévu',
  in_progress: 'En cours',
  awaiting_report: 'Compte rendu',
  completed: 'Réalisé',
  cancelled_by_parent: 'Annulé-Parent',
  cancelled_by_tutor: 'Annulé-Répétiteur',
};

export const SESSION_STATUS_COLORS = {
  scheduled: { bg: 'bg-blue-100', text: 'text-blue-800' },
  in_progress: { bg: 'bg-yellow-100', text: 'text-yellow-800' },
  awaiting_report: { bg: 'bg-orange-100', text: 'text-orange-800' },
  completed: { bg: 'bg-green-100', text: 'text-green-800' },
  cancelled_by_parent: { bg: 'bg-red-100', text: 'text-red-800' },
  cancelled_by_tutor: { bg: 'bg-red-100', text: 'text-red-700' },
};

/**
 * ProfileStatus labels and Tailwind color classes
 * Values from: app/Enums/ProfileStatus.php
 */
export const PROFILE_STATUS_LABELS = {
  draft: 'Brouillon',
  pending_verification: 'En attente de vérification',
  verified: 'Vérifié',
  suspended: 'Suspendu',
};

export const PROFILE_STATUS_COLORS = {
  draft: { bg: 'bg-gray-100', text: 'text-gray-700' },
  pending_verification: { bg: 'bg-yellow-100', text: 'text-yellow-800' },
  verified: { bg: 'bg-green-100', text: 'text-green-800' },
  suspended: { bg: 'bg-red-100', text: 'text-red-800' },
};
